import superagent from 'superagent'

const fetchHuntPlannerStaate = payload => ({
    type: 'HUNT_PLANNER_STATES_DATA',
    payload: payload
})

export const fetchHuntPlannerLayers = (cb) => (dispatch, getState, token) => {
    return new Promise((resolve, reject) => {
        superagent
            .get(`${__API_URI__}/HuntPlanner/GetStates`)
            .set('Content-Type', 'application/json')
            .set('Authorization', `Bearer ${token}`)
            .set('Platform', 'Web')
            .set('Version', `${__version__}`)
            .end((err, res) => {
                if (err) {
                    return resolve(err.status)
                }
                cb({ response: res.body })
                dispatch(fetchHuntPlannerStaate(res.body))
            })
    })
}


export const fetchHuntPlannerLayersInitial = () => (dispatch, getState, token) => {
    return new Promise(resolve => {
        superagent
            .get(`${__API_URI__}/HuntPlanner/GetStates`)
            .set('Authorization', `Bearer ${token}`)
            .set('Content-Type', 'application/json')
            .set('Platform', 'Web')
            .set('Version', `${__version__}`)
            .end((err, res) => {
                if (err) {
                    return
                }

                resolve(res.body.results)
                if (res.body) {
                    dispatch(fetchHuntPlannerStaate(res.body))
                }
            })
    })
}